










import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { filterPhone } from '~/assets/filters/phone'

@Component({
  filters: {
    filterPhone,
  },
})
export default class ComponentHiddenPhone extends Vue {
  @Prop({ type: String, default: () => {} }) readonly phone: string

  private isShow = false

  private onclick() {
    this.$emit('click')
    this.isShow = true
  }
}
